import React, { useContext, useEffect, useRef, useState } from "react";
import "../../css_files/Homepage/Overview.css";
import { Chart } from "chart.js/auto";
import axiosInstance from "../../api";
import { triggerscroll } from "./Homepage";
import ETQGraphs from "../Reports/ETQGraphs";
import OrderGraphs from "../Reports/OrderGraphs";
import { useNavigate } from "react-router-dom";
import ETQGraphDetails from "../Reports/ETQGraphDetails";

function Overview({ showsidebar }) {
  const chartRef = useRef([]);
  const chartInstanceRef = useRef([]);
  const lineref = useRef();
  const {
    setExpiredSession,
    showRemainingDashboard,
    setShowRemainingDashboard,
  } = useContext(triggerscroll);
  const [year, setYear] = useState(new Date().getFullYear());
  const [currencyData, setCurrencyData] = useState([]);
  const [ticketsData, setTicketsData] = useState([]);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [totalSales, setTotalSales] = useState(0);
  const [currency, setcurrency] = useState({
    code: "INR",
    rate: "1",
  });
  const [showDetails, setShowDetails] = useState(false);
  const [details, setDetails] = useState([[]]);
  const [headings, setHeadings] = useState([]);
  const [type, setType] = useState("Service");
  const [servicefinancialData, setServiceFinancialData] = useState({
    totalAmountToPay: 0,
    AmountPaid: 0,
    DueAmount: 0,
  });
  const [ticketAccessData, setTicketAccessData] = useState({
    PassedDueDates: [],
    ClosedDeals: [],
  });

  const [partsfinancialData, setPartsFinancialData] = useState({
    totalAmountToPay: 0,
    AmountPaid: 0,
    DueAmount: 0,
  });
  const [customers, setCustomers] = useState({
    customerQuotations: [],
    customerOrders: [],
  });
  const nav = useNavigate();

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/DashboardReport/GetSalesProjections?type=Service&currencyCode=${currency.code}&year=${year}`
      )
      .then((res) => {
        const totalAmountToPay = res.data.reduce(
          (acc, curr) => acc + curr.totalAmountToPay,
          0
        );
        const amountPaid = res.data.reduce(
          (acc, curr) => acc + curr.amountPaid,
          0
        );
        setServiceFinancialData({
          totalAmountToPay,
          AmountPaid: amountPaid,
          DueAmount: parseInt(totalAmountToPay) - parseInt(amountPaid),
        });
      })
      .catch(console.log);

    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/DashboardReport/GetSalesProjections?type=Parts&currencyCode=${currency.code}&year=${year}`
      )
      .then((res) => {
        const totalAmountToPay = res.data.reduce(
          (acc, curr) => acc + curr.totalAmountToPay,
          0
        );
        const amountPaid = res.data.reduce(
          (acc, curr) => acc + curr.amountPaid,
          0
        );
        setPartsFinancialData({
          totalAmountToPay,
          AmountPaid: amountPaid,
          DueAmount: parseInt(totalAmountToPay) - parseInt(amountPaid),
        });
      })
      .catch(console.log);
  }, [year, currency, currencyData]);

  useEffect(() => {
    getSalesProjection();

    return () => {
      chartInstanceRef.current[0]?.destroy();
    };
  }, [year, currency, currencyData, type]);

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/DashboardReport/GetSales?type=${type}&currencyCode=${currency.code}&year=${year}&month=${month}`
      )
      .then((res) => {
        setTotalSales(res.data.amountPaid);
      })
      .catch(console.log);
  }, [year, month, currency, type, currencyData]);

  async function getSalesProjection() {
    if (!chartRef.current) return;
    const ctx = chartRef.current[0].getContext("2d");

    try {
      const finalSales = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/api/DashboardReport/GetSalesProjections?type=${type}&currencyCode=${currency.code}&year=${year}`
      );

      const labels = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      if (chartInstanceRef.current[0]) chartInstanceRef.current[0].destroy();
      chartInstanceRef.current[0] = new Chart(ctx, {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              label: `${type} Sales Projection in Year (${year})`,
              data: labels.map((_, i) =>
                finalSales.data.some((x) => x.month - 1 === i)
                  ? finalSales.data.find((x) => x.month - 1 === i)?.amountPaid
                  : 0
              ),
              borderWidth: 2,
              borderColor: "blue",
              backgroundColor: "rgba(0, 0, 255, 0.1)",
              tension: 0.3,
            },
          ],
        },
        options: {
          responsive: true,
          onClick: (e, elements) => {
            if (elements.length > 0)
              nav(
                `/dashboard/detail/report?month=${
                  elements[0].index + 1
                }&year=${year}&type=${type}`
              );
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: (context) =>
                  `${currency.code} ${context.formattedValue}`,
              },
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: `Total Sales (in ${currency.code})`,
                color: "#000",
                font: {
                  size: 14,
                  weight: "bold",
                },
              },
            },
          },
        },
      });
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Ticket/GetAllTicketStatus`)
      .then((res) => {
        getTicketStatus(res?.data?.map((x) => x.status));
      })
      .catch(console.log);

    return () => {
      chartInstanceRef.current[1]?.destroy();
    };
  }, [year, type, ticketsData]);

  function getTicketStatus(statuses) {
    if (!chartRef.current) return;

    const ctx = chartRef.current[1].getContext("2d");

    const statusCounts = statuses.map((status) =>
      ticketsData
        .filter((x) => x.seriesId.slice(0, 4) == year)
        .reduce((acc, curr) => {
          if (curr.enquiryType === type && curr.status === status) {
            return acc + 1;
          }
          return acc;
        }, 0)
    );

    if (chartInstanceRef.current[1]) chartInstanceRef.current[1].destroy();
    chartInstanceRef.current[1] = new Chart(ctx, {
      type: "pie",
      data: {
        labels: statuses,
        datasets: [
          {
            label: "Ticket Status Breakdown",
            data: statusCounts,
            backgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#9966FF",
              "#FF9F40",
              "#4BC0C0",
              "#C9CBCF",
              "#FF6384",
            ],
            hoverOffset: 4,
          },
        ],
      },
    });
  }

  function getTopSellingProductsofTheMonth() {
    if (chartRef.current) {
      const ctx = chartRef.current[2].getContext("2d");

      return new Chart(ctx, {
        type: "bar",
        data: {
          labels: [
            "Jan",
            "Feb",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
          datasets: [
            {
              label: "Sales Projection",
              data: [12, 19, 3, 5, 2, 3],
              borderWidth: 1,
              borderColor: "blue",
            },
          ],
        },
        options: {
          indexAxis: "y",
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
    }
    return null;
  }

  function getTopSellingProducts() {
    if (chartRef.current) {
      const ctx = chartRef.current[3].getContext("2d");

      return new Chart(ctx, {
        type: "bar",
        data: {
          labels: [
            "Jan",
            "Feb",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
          datasets: [
            {
              label: "Sales Projection",
              data: [12, 19, 3, 5, 2, 3],
              borderWidth: 1,
              borderColor: "blue",
            },
          ],
        },
        options: {
          indexAxis: "y",
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
    }
    return null;
  }

  function top5Customers() {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Customer/GetTop5Customers?keyword=Quotations`
      )
      .then((res) => {
        axiosInstance
          .get(
            `${process.env.REACT_APP_API_URL}/api/v1/Customer/GetTop5Customers?keyword=Orders`
          )
          .then((resp) => {
            setCustomers({
              customerQuotations: res.data,
              customerOrders: resp.data,
            });
          })
          .catch(console.log);
      })
      .catch(console.log);
  }

  useEffect(() => {
    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShowRemainingDashboard(true);
          }
        });
      },
      {
        root: null,
        threshold: 0.1,
      }
    );

    if (lineref.current) intersectionObserver.observe(lineref.current);

    getAllCurrencies();
    getAllTickets();
    top5Customers();
    getTicketAccessData();
    return () => intersectionObserver.disconnect();
  }, []);

  function getAllCurrencies() {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Currency/GetCurrencyDropdown`
      )
      .then((res) => {
        setCurrencyData(res.data);
      })
      .catch(console.log);
  }

  function getAllTickets() {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Ticket/GetTicketsDropdown`)
      .then((res) => {
        setTicketsData(res.data);
      })
      .catch(console.log);
  }

  function getTicketAccessData() {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Technician/GetTop10Technician?keyword=Status`
      )
      .then((res) => {
        axiosInstance
          .get(
            `${process.env.REACT_APP_API_URL}/api/v1/Technician/GetTop10Technician?keyword=DueDate`
          )
          .then((resp) => {
            setTicketAccessData({
              ClosedDeals: res.data,
              PassedDueDates: resp.data,
            });
          })
          .catch(console.log);
      })
      .catch(console.log);
  }

  return (
    <>
      <section className="overview">
        <h1>Dashboard </h1>
        <div>
          <h1>ROSS BOILERS</h1>
          <select onChange={(e) => setMonth(e.target.value)}>
            <option value="">Select Month</option>
            <option value="01" selected={month === 1}>
              January
            </option>
            <option value="02" selected={month === 2}>
              February
            </option>
            <option value="03" selected={month === 3}>
              March
            </option>
            <option value="04" selected={month === 4}>
              April
            </option>
            <option value="05" selected={month === 5}>
              May
            </option>
            <option value="06" selected={month === 6}>
              June
            </option>
            <option value="07" selected={month === 7}>
              July
            </option>
            <option value="08" selected={month === 8}>
              August
            </option>
            <option value="09" selected={month === 9}>
              September
            </option>
            <option value="10" selected={month === 10}>
              October
            </option>
            <option value="11" selected={month === 11}>
              November
            </option>
            <option value="12" selected={month === 12}>
              December
            </option>
          </select>
          <select onChange={(e) => setYear(e.target.value)}>
            <option value="">Select Year</option>
            {Array.from({ length: 150 }, (_, i) => `${1970 + i}`).map((x) => (
              <option value={x} selected={year === parseInt(x)}>
                {x}
              </option>
            ))}
          </select>
          <select onChange={(e) => setType(e.target.value)}>
            <option value="">Select Type</option>
            <option value="Service" selected={type === "Service"}>
              Service
            </option>
            <option value="Parts" selected={type === "Parts"}>
              Parts
            </option>
          </select>
          <select
            onChange={(e) =>
              setcurrency({
                code: e.target.value?.split(" ")[0],
                rate: e.target.value?.split(" ")[1],
              })
            }
          >
            <option value="">Select Currency</option>
            {currencyData.map((x) => (
              <option
                value={`${x.code} ${x.rate}`}
                selected={
                  `${currency.code} ${currency.rate}` === `${x.code} ${x.rate}`
                }
              >
                {x.code}
              </option>
            ))}
          </select>
        </div>
        <div>
          <blockquote>
            <h2>Total Sales</h2>
            <h1>
              {currency.code} {Math.round(totalSales || 0)}
            </h1>
            <h4>
              {month.toString().padStart(2, "0")}/{year}
            </h4>
          </blockquote>
          <blockquote>
            <h2>FOC Visits</h2>
            <h1>
              {ticketsData.reduce((acc, curr) => {
                if (
                  curr?.serviceType === "FOC" &&
                  curr?.enquiryType === "Service" &&
                  curr?.seriesId?.slice(0, 4) == year &&
                  curr?.seriesId?.slice(4, 6) == month
                ) {
                  return acc + 1;
                }
                return acc;
              }, 0)}
            </h1>
          </blockquote>
          <blockquote>
            <h2>FOC Spares</h2>
            <h1>
              {ticketsData.reduce((acc, curr) => {
                if (
                  curr.serviceType === "FOC" &&
                  curr.enquiryType === "Parts" &&
                  curr.seriesId.slice(0, 4) == year &&
                  curr.seriesId.slice(4, 6) == month
                ) {
                  return acc + 1;
                }
                return acc;
              }, 0)}
            </h1>
          </blockquote>
          <blockquote>
            <h2>Paid Visits</h2>
            <h1>
              {ticketsData.reduce((acc, curr) => {
                if (
                  curr.serviceType === "Paid" &&
                  curr.enquiryType === "Service" &&
                  curr.seriesId.slice(0, 4) == year &&
                  curr.seriesId.slice(4, 6) == month
                ) {
                  return acc + 1;
                }
                return acc;
              }, 0)}
            </h1>
          </blockquote>
          <blockquote>
            <h2>Paid Spares</h2>
            <h1>
              {ticketsData.reduce((acc, curr) => {
                if (
                  curr.serviceType === "Paid" &&
                  curr.enquiryType === "Parts" &&
                  curr.seriesId.slice(0, 4) == year &&
                  curr.seriesId.slice(4, 6) == month
                ) {
                  return acc + 1;
                }
                return acc;
              }, 0)}
            </h1>
          </blockquote>
          <blockquote>
            <h2>Dispatched</h2>
            <h1>0</h1>
          </blockquote>
        </div>
        <section>
          <div>
            <div style={{ flexDirection: "row" }}>
              <aside style={{ flexBasis: "75%" }}>
                <h2>Sales Projection</h2>
                <figure>
                  <canvas ref={(el) => (chartRef.current[0] = el)}></canvas>
                </figure>
              </aside>
              <aside style={{ flexBasis: "25%" }}>
                <h2>
                  Ticket Status ({type}) in {year}
                </h2>
                <figure>
                  <canvas ref={(el) => (chartRef.current[1] = el)}></canvas>
                </figure>
              </aside>
            </div>
            <aside>
              {/*
            <h2>Technician Performance</h2>
            <table>
              <thead>
                <tr>
                  <th>Po</th>
                  <th>Name</th>
                  <th>Visits</th>
                  <th>Tickets</th>
                  <th>Tickets Pending</th>
                  <th>Invoices</th>
                  <th>Spares</th>
                  <th>Saves Payment</th>
                  <th>Spare Payment</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <i className="fa-solid fa-check"></i>
                  </td>
                  <td>
                    <i className="fa-solid fa-user-circle"></i>
                    <span style={{ marginLeft: "5px" }}>Raj</span>
                  </td>
                  <td>4</td>
                  <td>8</td>
                  <td>2</td>
                  <td>INR 85000</td>
                  <td>INR 65000</td>
                  <td>INR 25000</td>
                  <td>INR 35000</td>
                </tr>
              </tbody>
            </table>*/}
            </aside>
            {showRemainingDashboard && <OrderGraphs />}
          </div>
          <div>
            <aside>
              <blockquote>
                <h2>Financial Summary in {year}</h2>
                <dl>
                  <dt>Enquiry Type</dt>
                  <dd>Service</dd>
                  <dt>Total Invoices</dt>
                  <dd>
                    {currency.code}{" "}
                    {Math.round(servicefinancialData.totalAmountToPay)}
                  </dd>
                  <dt>Payments Received</dt>
                  <dd>
                    {currency.code}{" "}
                    {Math.round(servicefinancialData.AmountPaid)}
                  </dd>
                  <dt>Pending Payments</dt>
                  <dd>
                    {currency.code} {Math.round(servicefinancialData.DueAmount)}
                  </dd>
                </dl>
              </blockquote>
            </aside>
            <aside>
              <blockquote>
                <h2>Financial Summary in {year}</h2>
                <dl>
                  <dt>Enquiry Type</dt>
                  <dd>Parts</dd>
                  <dt>Total Invoices</dt>
                  <dd>
                    {currency.code}{" "}
                    {Math.round(partsfinancialData.totalAmountToPay)}
                  </dd>
                  <dt>Payments Received</dt>
                  <dd>
                    {currency.code} {Math.round(partsfinancialData.AmountPaid)}
                  </dd>
                  <dt>Pending Payments</dt>
                  <dd>
                    {currency.code} {Math.round(partsfinancialData.DueAmount)}
                  </dd>
                </dl>
              </blockquote>
            </aside>
            <aside>
              <blockquote>
                <h3>Top 5 Customers who asked Quotations</h3>
                <dl style={{ gridTemplateColumns: "1fr 1fr 1fr" }}>
                  {customers.customerQuotations.map((x) => (
                    <>
                      <dt style={{ gridColumn: "span 2" }}>{x?.orgName}</dt>
                      <dd>{x?.quotations}</dd>
                    </>
                  ))}
                </dl>
              </blockquote>
            </aside>
            <aside>
              <blockquote>
                <h3>Top 5 Customers for whom orders placed</h3>
                <dl style={{ gridTemplateColumns: "1fr 1fr 1fr" }}>
                  {customers.customerOrders.map((x) => (
                    <>
                      <dt style={{ gridColumn: "span 2" }}>{x?.orgName}</dt>
                      <dd>{x?.orders}</dd>
                    </>
                  ))}
                </dl>
              </blockquote>
            </aside>
            <aside>
              <blockquote>
                <h3>Top 10 technician who closed the deal</h3>
                <dl style={{ gridTemplateColumns: "1fr 1fr 1fr" }}>
                  {ticketAccessData.ClosedDeals.map((x) => (
                    <>
                      <dt style={{ gridColumn: "span 2" }}>{x?.userId}</dt>
                      <dd>{x?.count}</dd>
                    </>
                  ))}
                </dl>
              </blockquote>
            </aside>
            <aside>
              <blockquote>
                <h3>top 10 technician who passed due dates </h3>
                <dl style={{ gridTemplateColumns: "1fr 1fr 1fr" }}>
                  {ticketAccessData.PassedDueDates.map((x) => (
                    <>
                      <dt style={{ gridColumn: "span 2" }}>{x?.userId}</dt>
                      <dd>{x?.count}</dd>
                    </>
                  ))}
                </dl>
              </blockquote>
            </aside>
          </div>
        </section>
        {showRemainingDashboard && (
          <>
            <ETQGraphs
              title="Enquiries"
              setShowDetails={setShowDetails}
              setDetails={setDetails}
              setHeadings={setHeadings}
            />
            <ETQGraphs
              title="Tickets"
              setShowDetails={setShowDetails}
              setDetails={setDetails}
              setHeadings={setHeadings}
            />
            <ETQGraphs
              title="Quotations"
              setShowDetails={setShowDetails}
              setDetails={setDetails}
              setHeadings={setHeadings}
            />
            <ETQGraphs
              title="Combination"
              setShowDetails={setShowDetails}
              setDetails={setDetails}
              setHeadings={setHeadings}
            />
          </>
        )}
      </section>
      <hr ref={lineref} />
      {showDetails && (
        <ETQGraphDetails
          headings={headings}
          details={details}
          setShowDetails={setShowDetails}
        />
      )}
    </>
  );
}

export default Overview;
